import { createVanIconComponent } from "./van"

const InfoOutlined = createVanIconComponent("info-o")
export default InfoOutlined
